/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { Client } from 'fierry/flux';

import Rpc from 'shared/alias/rpc';
import State from 'shared/client/time/state';



export default new Client ([ State, Rpc ], class
{
  constructor ([ state, dispatch ], rpc)
  {
    this.state = state;
    this.dispatch = dispatch;

    this.record = rpc ? rpc.getCurrentTime() : null;
  }


  getClientDate ()
  {
    if (!this.record)
    {
      return null;
    }

    return this.isRealTime() ? this.record.getClientDate(this.state) : this.record.getClientDate();
  }


  getServerDate ()
  {
    if (!this.record)
    {
      return null;
    }

    return this.isRealTime() ? this.record.getServerDate(this.state) : this.record.getServerDate();
  }


  isRealTime ()
  {
    return this.record ? this.record.isRealTime() : false;
  }


  isServerDelayed ()
  {
    return this.record ? this.record.isServerDelayed() : false;
  }


  getServerDelay ()
  {
    return this.record.getServerDelay();
  }


});
